export const columns = [
  {
    title: "N",
    dataIndex: "id",
    key: "id",
    defaultFlex: 0.5,
  },
  {
    title: "Դասարան",
    dataIndex: "school",
    key: "school",
    defaultFlex: 0.7,
  },
  {
    title: "Առարկան՝ ըստ պետական պարտադիր առարկայացանկի",
    dataIndex: "subjects",
    key: "subjects",
    defaultFlex: 1,
  },
  {
    title: "ուսումնական առարկայի պարտադիր նվազագույն ժամաքանակ",
    dataIndex: "hours",
    key: "hours",
    defaultFlex: 1,
  },
  {
    title:
      "ուսումնական առարկային դպրոցական բաղադրիչից հատկացվող ցանկալի ժամաքանակ",
    dataIndex: "schoolHours",
    key: "schoolHours",
    defaultFlex: 1,
  },
  {
    title:
      "ուսումնական առարկային անհատական բաղադրիչից հատկացվող ցանկալի ժամաքանակ",
    dataIndex: "individualHours",
    key: "individualHours",
    defaultFlex: 1,
  },
];

export const rows = [
  {
    id: 1,
    school: "10֊րդ",
    subjects: [
      "Հայոց լեզու",
      "Հայ Գրականություն",
      "Հայոց պատմություն",
      "Հասարակագիտություն",
      "Աշխարհագրություն",
    ],
    hours:            [2, 3, 2,  2,  "-"],
    schoolHours:      [2, 2, 2, "-", 3],
    individualHours:  [2, 2, 2, "-", 3],
  },
  {
    id: 2,
    school: "11֊րդ",
    subjects: [
      "Հայոց լեզու",
      "Գրականություն",
      "Հայոց պատմություն",
      "Հասարակագիտություն",
      "Աշխարհագրություն",
    ],
    hours:            [2, 3, 2,  2,  "-"],
    schoolHours:      [2, 2, 2, "-", 3],
    individualHours:  [2, 2, 2, "-", 3],
  },
  {
    id: 3,
    school: "12֊րդ",
    subjects: [
      "Հայոց լեզու",
      "Գրականություն",
      "Հայոց պատմություն",
      "Հասարակագիտություն",
      "Աշխարհագրություն",
    ],
    hours:            [2, 3, 2,  2,  "-"],
    schoolHours:      [2, 2, 2, "-", 3],
    individualHours:  [2, 2, 2, "-", 3],
  },
];
